/**
 * RAD Truck Straps — rad-fitment-finder.js
 * Cascading Year/Make/Model dropdowns with compatibility result panel.
 *
 * Depends on: rad-fitment-data.js (must load first)
 * Upload both to Admin > Content > Files
 */

(function () {
  'use strict';

  /* Guard */
  if (window.__radFitmentLoaded) return;
  window.__radFitmentLoaded = true;

  /* ─── Wait for DOM + data ───────────────────────────────────── */
  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  onReady(function () {
    var instances = document.querySelectorAll('[data-rad-fitment]');
    instances.forEach(initFinder);
  });

  /* ─── Init a single finder instance ────────────────────────── */
  function initFinder(root) {
    var selYear  = root.querySelector('[data-rad-year]');
    var selMake  = root.querySelector('[data-rad-make]');
    var selModel = root.querySelector('[data-rad-model]');
    var result   = root.querySelector('[data-rad-result]');
    var resetBtn = root.querySelector('[data-rad-reset]');

    if (!selYear || !selMake || !selModel || !result) return;

    /* Ensure data is loaded */
    if (!window.RAD_FITMENT || !window.RAD_FITMENT_MAKES) {
      console.warn('[RAD Fitment] rad-fitment-data.js not loaded.');
      return;
    }

    /* ── Populate Make dropdown ── */
    window.RAD_FITMENT_MAKES.forEach(function (make) {
      var opt = document.createElement('option');
      opt.value = make;
      opt.textContent = make;
      selMake.appendChild(opt);
    });

    /* ── Year → enable Make ── */
    selYear.addEventListener('change', function () {
      resetFromYear();
    });

    /* ── Make → populate Model ── */
    selMake.addEventListener('change', function () {
      resetFromMake();
      var make = selMake.value;
      if (!make) return;

      selModel.disabled = false;
      selModel.innerHTML = '<option value="">Select Model</option>';
      var models = Object.keys(window.RAD_FITMENT[make] || {});
      models.forEach(function (model) {
        var opt = document.createElement('option');
        opt.value = model;
        opt.textContent = model;
        selModel.appendChild(opt);
      });
      updateWrapState(selModel, false);
    });

    /* ── Model → show result ── */
    selModel.addEventListener('change', function () {
      clearResult();
      var year  = parseInt(selYear.value, 10);
      var make  = selMake.value;
      var model = selModel.value;
      if (!year || !make || !model) return;
      showResult(year, make, model, result);
      if (resetBtn) resetBtn.classList.add('rad-fitment__reset--visible');
    });

    /* ── Reset ── */
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        resetAll();
      });
    }

    /* ─── Helpers ─────────────────────────────────────────────── */

    function resetAll() {
      selYear.value  = '';
      selMake.value  = '';
      selModel.value = '';
      selMake.disabled  = true;
      selModel.disabled = true;
      selModel.innerHTML = '<option value="">Select Model</option>';
      updateWrapState(selMake, true);
      updateWrapState(selModel, true);
      clearResult();
      if (resetBtn) resetBtn.classList.remove('rad-fitment__reset--visible');
    }

    function resetFromYear() {
      selMake.value  = '';
      selModel.value = '';
      selModel.innerHTML = '<option value="">Select Model</option>';
      clearResult();

      if (selYear.value) {
        selMake.disabled = false;
        updateWrapState(selMake, false);
      } else {
        selMake.disabled  = true;
        selModel.disabled = true;
        updateWrapState(selMake, true);
        updateWrapState(selModel, true);
      }
      if (resetBtn) resetBtn.classList.remove('rad-fitment__reset--visible');
    }

    function resetFromMake() {
      selModel.value = '';
      selModel.innerHTML = '<option value="">Select Model</option>';
      selModel.disabled = true;
      updateWrapState(selModel, true);
      clearResult();
      if (resetBtn) resetBtn.classList.remove('rad-fitment__reset--visible');
    }

    function clearResult() {
      result.className = 'rad-fitment__result';
      result.innerHTML = '';
    }

    function updateWrapState(sel, disabled) {
      var wrap = sel.closest('.rad-fitment__select-wrap');
      if (!wrap) return;
      if (disabled) {
        wrap.classList.add('rad-fitment__select-wrap--disabled');
      } else {
        wrap.classList.remove('rad-fitment__select-wrap--disabled');
      }
    }
  }

  /* ─── Render result panel ───────────────────────────────────── */
  function showResult(year, make, model, resultEl) {
    var data = (window.RAD_FITMENT[make] || {})[model];

    /* Unknown vehicle */
    if (!data) {
      renderNoFit(resultEl, year, make, model,
        'We don\'t have a listed fitment for this vehicle yet. Reach out and we\'ll let you know what\'s in development.'
      );
      return;
    }

    var minYear = data.years[0];
    var maxYear = data.years[1];

    /* Year out of supported range */
    if (year < minYear || year > maxYear) {
      renderYearRange(resultEl, year, make, model, minYear, maxYear);
      return;
    }

    /* Compatible */
    renderCompatible(resultEl, year, make, model, data);
  }

  /* ─── Compatible result ─────────────────────────────────────── */
  function renderCompatible(el, year, make, model, data) {
    var isBoxLink   = data.type === 'boxlink';
    var badgeClass  = isBoxLink ? 'rad-fitment__mount-badge--boxlink' : 'rad-fitment__mount-badge--universal';
    var badgeLabel  = isBoxLink ? 'BoxLink Fit' : 'Universal Plate';
    var productUrl  = '/products/' + data.handle;

    el.className = 'rad-fitment__result rad-fitment__result--compatible';
    el.innerHTML =
      '<div class="rad-fitment__result-inner">' +
        '<div class="rad-fitment__result-top">' +
          '<div>' +
            '<div class="rad-fitment__result-label">Compatible</div>' +
            '<div class="rad-fitment__result-vehicle">' + year + ' ' + make + ' ' + model + '</div>' +
            '<div class="rad-fitment__result-note">' + escHtml(data.note) + '</div>' +
            '<div class="rad-fitment__dot-row">' +
              '<span class="rad-fitment__micro-badge rad-fitment__micro-badge--dot">DOT Certified</span>' +
              '<span class="rad-fitment__micro-badge rad-fitment__micro-badge--usa">Made in USA</span>' +
              '<span class="rad-fitment__micro-badge rad-fitment__micro-badge--patent">Patent No. 12594871</span>' +
            '</div>' +
          '</div>' +
          '<span class="rad-fitment__mount-badge ' + badgeClass + '">' + badgeLabel + '</span>' +
        '</div>' +
        '<a href="' + productUrl + '" class="rad-fitment__cta" data-rad-cta>' +
          'Get My Kit' +
          '<span class="rad-fitment__cta-arrow" aria-hidden="true">&#8594;</span>' +
        '</a>' +
      '</div>';

    /* Reveal */
    requestAnimationFrame(function () {
      el.classList.add('rad-fitment__result--visible');
    });

    /* Wire Add to Cart shortcut */
    wireAtc(el, data);
  }

  /* ─── Year out of range ─────────────────────────────────────── */
  function renderYearRange(el, year, make, model, min, max) {
    el.className = 'rad-fitment__result rad-fitment__result--year-range';
    el.innerHTML =
      '<div class="rad-fitment__result-inner">' +
        '<div class="rad-fitment__result-label">Year Not in Range</div>' +
        '<div class="rad-fitment__result-vehicle">' + year + ' ' + make + ' ' + model + '</div>' +
        '<div class="rad-fitment__result-note">' +
          'RAD Truck Straps currently fits the ' + make + ' ' + model + ' from ' + min + ' to ' + max + '. ' +
          'Your ' + year + ' model is outside the listed range. Contact us &mdash; compatibility may still be possible.' +
        '</div>' +
        '<a href="/pages/contact" class="rad-fitment__contact-cta">' +
          'Ask About Your Truck &#8594;' +
        '</a>' +
      '</div>';

    requestAnimationFrame(function () {
      el.classList.add('rad-fitment__result--visible');
    });
  }

  /* ─── No fit ────────────────────────────────────────────────── */
  function renderNoFit(el, year, make, model, message) {
    el.className = 'rad-fitment__result rad-fitment__result--no-fit';
    el.innerHTML =
      '<div class="rad-fitment__result-inner">' +
        '<div class="rad-fitment__result-label">Not Listed Yet</div>' +
        '<div class="rad-fitment__result-vehicle">' + year + ' ' + make + ' ' + model + '</div>' +
        '<div class="rad-fitment__result-note">' + escHtml(message) + '</div>' +
        '<a href="/pages/contact" class="rad-fitment__contact-cta">' +
          'Contact Us About This Truck &#8594;' +
        '</a>' +
      '</div>';

    requestAnimationFrame(function () {
      el.classList.add('rad-fitment__result--visible');
    });
  }

  /* ─── Add to Cart shortcut ──────────────────────────────────── */
  /*
   * If the visitor is on a PDP (product page), attempt to pre-select
   * the correct variant and scroll to the ATC button.
   * If on homepage or a non-product page, the CTA link goes to /products/[handle].
   */
  function wireAtc(resultEl, data) {
    var ctaEl = resultEl.querySelector('[data-rad-cta]');
    if (!ctaEl) return;

    /* Only attempt variant pre-selection on product pages */
    if (!window.Shopify || typeof window.Shopify.product === 'undefined') {
      /* Not a product page — link behavior is sufficient */
      return;
    }

    /* On PDP: find the matching variant by title and select it */
    ctaEl.addEventListener('click', function (e) {
      e.preventDefault();

      /* Try to find and click the matching variant selector */
      var variantHint = data.variantHint || '';
      var selected    = false;

      /* Dawn theme uses <variant-selects> custom element */
      /* Try radio inputs first (Dawn default) */
      var radios = document.querySelectorAll('input[type="radio"][name*="option"]');
      radios.forEach(function (radio) {
        if (radio.value && variantHint &&
            radio.value.toLowerCase().indexOf(variantHint.toLowerCase()) !== -1) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          selected = true;
        }
      });

      /* Dawn also uses <select> for variant options */
      if (!selected) {
        var variantSelects = document.querySelectorAll('select[name*="option"], .product-form__input select');
        variantSelects.forEach(function (sel) {
          var options = sel.querySelectorAll('option');
          options.forEach(function (opt) {
            if (variantHint && opt.text.toLowerCase().indexOf(variantHint.toLowerCase()) !== -1) {
              sel.value = opt.value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              selected = true;
            }
          });
        });
      }

      /* Scroll to and highlight ATC button */
      var atcBtn = document.querySelector('[name="add"], .product-form__submit, button[data-add-to-cart]');
      if (atcBtn) {
        atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        /* Pulse animation */
        atcBtn.style.transition = 'box-shadow 0.3s';
        atcBtn.style.boxShadow = '0 0 0 4px rgba(196, 148, 38, 0.5)';
        setTimeout(function () {
          atcBtn.style.boxShadow = '0 0 0 0px rgba(196, 148, 38, 0)';
        }, 900);
      } else {
        /* Fallback: navigate to product page */
        window.location.href = ctaEl.href;
      }
    });
  }

  /* ─── XSS-safe HTML escape ──────────────────────────────────── */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();